import { textFormatter } from "components/Common/formatter";
import ButtonGroupContainer from "components/Common/buttons/ButtonGroupContainer";
import ButtonGroup from "components/Common/buttons/ButtonGroup";
import editIcon from "assets/images/svg/Edit.svg";
import React from "react";
import deleteIcon from "assets/images/svg/Delete.svg";
import { userHasOneOfRoles } from "utils/helpers/functions";
import { AUTH_USER, USER_ROLES } from "utils/constants";

export const smartScalesColumns = setActiveItem => [
  {
    title: "Serial Number",
    dataIndex: "serialNumber",
    render: textFormatter,
  },
  {
    title: "Depot",
    dataIndex: "depot",
    render: textFormatter,
  },
  {
    title: "Assigned DSC",
    dataIndex: "assignedTo",
    render: textFormatter,
  },
  {
    dataIndex: "",
    title: "",
    width: "60px",
    render: row => (
      <ButtonGroupContainer hasMobileView>
        <ButtonGroup
          tooltipTitle="Edit"
          disabled={
            userHasOneOfRoles([USER_ROLES.DEPOT_CLERK, USER_ROLES.OPERATION_MANAGERS]) &&
            row.depot !== AUTH_USER()?.depotName
          }
          icon={editIcon}
          handleClick={() => setActiveItem(row)}
        />
        <ButtonGroup
          tooltipTitle="Delete"
          disabled={
            userHasOneOfRoles([USER_ROLES.DEPOT_CLERK, USER_ROLES.OPERATION_MANAGERS]) &&
            row.depot !== AUTH_USER()?.depotName
          }
          icon={deleteIcon}
          handleClick={() => setActiveItem(row, true)}
        />
      </ButtonGroupContainer>
    ),
  },
];
